<template>
  <article class="replace-pwa-with-mobile-app">
    <header class="page-header">
      <TheOrganizationLogo height="12" />
      <h1 class="title">Get the Best Experience</h1>
      <p>
        You're using our web app in standalone (PWA) mode. For the best performance and full functionality, we recommend
        downloading our <strong>native mobile app</strong>.
      </p>
    </header>

    <div class="page-links">
      <div class="app-store-links">
        <a
          v-if="showDownloadLinkForIOS"
          aria-label="Download from App Store"
          class="app-store-link apple-store"
          :href="appStoreConfig.appleStore.link"
        />
        <a
          v-if="showDownloadLinkForAndroid"
          aria-label="Download from Play Market"
          class="app-store-link play-market"
          :href="appStoreConfig.playMarket.link"
        />
      </div>
      <p>
        You can also uninstall the PWA and continue using the regular
        <a href="/" target="_blank" rel="noopener noreferrer">website</a>.
      </p>
    </div>
  </article>
</template>

<script>
import { mobileAppStoreConfig } from '@/helpers/mobileAppStoreConfig';
import TheOrganizationLogo from '@/components/logos/TheOrganizationLogo.vue';

export default {
  components: { TheOrganizationLogo },
  metaInfo: {
    title: 'Replace PWA - The Cultivist Members',
  },
  data() {
    return {
      appStoreConfig: mobileAppStoreConfig(),
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    },
    showDownloadLinkForAndroid() {
      return !this.device.isIOS;
    },
    showDownloadLinkForIOS() {
      return !this.device.isAndroid;
    },
  },
};
</script>

<style lang="scss">
.replace-pwa-with-mobile-app {
  padding: 32px 24px 24px;

  .page-header {
    text-align: center;
  }

  .title {
    margin: 40px 0 32px;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  p {
    margin-bottom: 8px;
  }

  strong {
    font-weight: 500;
  }

  .page-links {
    margin-top: 40px;
    text-align: center;
  }

  .app-store-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin-bottom: 24px;
  }

  .app-store-link {
    display: block;
    height: 40px;
    padding: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    &.apple-store {
      width: 120px;
      background-image: url(~@/assets/images/icons/download-app-store.svg);
    }
    &.play-market {
      width: 130px;
      background-image: url(~@/assets/images/icons/download-play-market.svg);
    }
  }
}
</style>
